import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AppContext } from './AppContext';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';

const SecuredRoute = ({ children }) => {

  const location = useLocation();
  const { isAuthenticated,user  } = useContext(AppContext);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <Header />
      <Sidebar />
      {children}
    </>
  );
};

export default SecuredRoute;
